exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".exception-list-item {\n  min-height: 72px; }\n\n.exception-row-checkbox {\n  -ms-flex-item-align: center;\n      -ms-grid-row-align: center;\n      align-self: center;\n  -ms-flex: 0 0 32px;\n      flex: 0 0 32px;\n  margin-right: 18px; }\n\n.exception-row-details {\n  min-width: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/exception/exception.component.scss
// module id = ../../../../../src/app/exception/exception.component.scss
// module chunks = 0